import { withInstall } from '../../utils'

import _Card from './src/card.vue'

export const SdCard = withInstall(_Card)
export default SdCard

export * from './src/card'
